var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-footer',[_c('div',{staticClass:"footerContent"},[_vm._v(_vm._s(_vm.typeHash == '#normal'?'编玩边学教育科技有限公司':'主办方：蓝桥杯组委会青少组'))])])}
var staticRenderFns = []

export { render, staticRenderFns }